module.exports = __webpack_public_path__ + "img/principios.96971103.png";